import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../CustomButton';
import { formatVehicleName, formatTimestamp } from '../../../helpers/tablesFuncHelpers';
import '../../../common/MobileGridCards.sass';

const FirmwareMobileCard = ({ row, editVehicle }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });

	const nameLabel = formatVehicleName(row.device_id, row);

	const baseData = [
		{ label: t('Group'), value: row.vehicle_group },
		{ label: t('Version'), value: row.firmware || '-' },
		{ label: t(('Updated Date').replace(/\s/g, '_')), value: formatTimestamp(row.firmware_updated_ts) },
		{ label: t(('Firmware Status').replace(/\s/g, '_')), value: row.firmware_status },
	];

	return (
		<Card className="mobile-grid-card">
			<Card.Body>
				<div className="mobile-card-header">
					<div className="mobile-card-info">
						<CustomButton variant="link" onClick={(e) => editVehicle(e, row.device_id)}>{nameLabel}</CustomButton>
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
							</div>
						))}
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default FirmwareMobileCard;
